import { useState } from "react";
import { useSelector } from "react-redux";
import NotifyAddTocart from "components/NotifyAddTocart";
import toast from "react-hot-toast";
//
const useUpdateProfile = ({ uploadImage }) => {
  //
  const notifyAddTocart = (message) => {
    toast.custom(
      (t) => <NotifyAddTocart show={t.visible} message={message} />,
      {
        position: "top-right",
        id: "nc-product-notify",
        duration: 5000,
      }
    );
  };
  //
  const { profile } = useSelector((state) => state.authSliceReducer);
  //
  const { address, email, full_name, mobile_number, profile_img, role, uid } =
    profile?.data;
  //
  //
  const [done, setDone] = useState(false);
  const [response, setResponse] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  //
  //
  const [profileformdata, setProfileFormData] = useState({
    profile_img: profile_img,
    uid: uid,
    full_name: full_name,
    mobile_number: mobile_number,
    email: email,
    address: address,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileFormData({
      ...profileformdata,
      [name]: value,
    });
  };

  //

  const closeModal = () => setResponse(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    // FormData
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    formData.append("key", "qwerty");

    // Trigger the mutation
    try {
      const data = await uploadImage(formData).unwrap();
      setProfileFormData({
        ...profileformdata,
        profile_img: data.image_url,
      });
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  return {
    done,
    response,
    open,
    setDone,
    handleChange,
    handleClose,
    uploadImage,
    closeModal,
    error,
    setError,
    setProfileFormData,
    profileformdata,
    handleUpload,
  };
};

export default useUpdateProfile;
